// extracted by mini-css-extract-plugin
module.exports = {"app":"App_app__2WQ0s","app--light":"App_app--light__1UDVT","app--dark":"App_app--dark__nZwao"};